/**
 * Index Controller
 */
(function(angular) {
    'use strict';

    var app = angular.module('asDemandMgr');

    app.controller('CampaignIndexController', [
        '$scope',
        '$timeout',
        'campaignApi',
        'optionsApi',
        function($scope, $timeout, campaignApi, optionsApi) {
            // select search input content on focus
            $('#search').click(function() {
                $(this).select();
            });

            $scope.loading = false;

            $scope.list = null;

            $scope.page = {
                number: 0,
                size: 100,
            };

            if (window.requestCampaignTypes.length) {
                $scope.campaignTypeFilter = window.requestCampaignTypes;
            } else {
                let campaignTypeFilterSavedRaw = window.localStorage.getItem('campaignTypeFilterSaved');
                try {
                    var campaignTypeFilterSaved = JSON.parse(campaignTypeFilterSavedRaw);
                } catch (e) {
                    var campaignTypeFilterSaved = null;
                }

                if (Array.isArray(campaignTypeFilterSaved)) {
                    $scope.campaignTypeFilter = campaignTypeFilterSaved;
                } else {
                    $scope.campaignTypeFilter = window.defaultCampaignTypes;
                }
            }

            var storedSearchTerm = window.localStorage.getItem('campaignSearchTerm');
            if (storedSearchTerm) {
                $scope.searchTerm = storedSearchTerm;
            } else {
                $scope.searchTerm = '';
            }

            var storedSelectedIo = parseInt(window.localStorage.getItem('ioFilter'));
            if (storedSelectedIo) {
                $scope.ioFilter = storedSelectedIo;
            } else {
                $scope.ioFilter = window.selectedIo ? window.selectedIo : '*';
            }

            if (window.selectedAdvertisers) {
                $scope.advertisersFilter = window.selectedAdvertisers ? window.selectedAdvertisers : [];
            } else {
                var storedSelectedAdvertisers = window.localStorage.getItem('advertisersFilter');
                if (storedSelectedAdvertisers) {
                    try {
                        $scope.advertisersFilter = JSON.parse(storedSelectedAdvertisers);
                        console.log("advertisersFilter parsed", $scope.advertisersFilter, "selected", window.selectedAdvertisers);
                    } catch (e) {
                        $scope.advertisersFilter = null;
                    }
                }
            }
            if (window.selectedAgencies) {
                $scope.agenciesFilter = window.selectedAgencies ? window.selectedAgencies : [];
            } else {
                var storedSelectedAgencies = window.localStorage.getItem('agenciesFilter');
                if (storedSelectedAgencies) {
                    try {
                        $scope.agenciesFilter = JSON.parse(storedSelectedAgencies);
                        console.log("agenciesFilter parsed", $scope.agenciesFilter, "selected", window.selectedAgencies);
                    } catch (e) {
                        $scope.agenciesFilter = null;
                    }
                }
            }
            if (window.selectedUsers) {
                $scope.usersFilter = window.selectedUsers ? window.selectedUsers : [];
            } else {
                var storedSelectedUsers = window.localStorage.getItem('usersFilter');
                if (storedSelectedUsers) {
                    try {
                        $scope.usersFilter = JSON.parse(storedSelectedUsers);
                        console.log("usersFilter parsed", $scope.usersFilter, "selected", window.selectedUsers);
                    } catch (e) {
                        $scope.usersFilter = null;
                    }
                }
            }


            $scope.sort = {
                //field: 'ts_updated',
                field: 'delivery_priority',
                order: 'desc',
            };

            /**
             * If user presses enter in search box perform the search
             * @param e
             */
            $scope.checkSubmit = function(e) {
                if (e.originalEvent.charCode === 13) {
                    $scope.search();
                }
            };

            $scope.filter = function() {
                $scope.page.number = 0;

                $scope.fetch();
            };

            $scope.exHdlFilter = window.exHdl;
            $scope.$watch('exHdlFilter', function(newVal, oldVal) {
                if (newVal !== oldVal) {
                    $scope.fetch();
                }
            }, true);

            $scope.$watch('campaignTypeFilter', function(newVal, oldVal) {
                if (newVal && oldVal && newVal !== oldVal) {
                    window.localStorage.setItem('campaignTypeFilterSaved', JSON.stringify($scope.campaignTypeFilter));
                    $scope.fetch();
                }
            }, true);

            $scope.statusFilter = ['running_active', 'running_stopped', 'not_started', 'paused'];
            $scope.$watch('statusFilter', function(newVal, oldVal) {
                if (newVal && oldVal && newVal !== oldVal) {
                    $scope.fetch();
                }
            }, true);

            var filterTimeout = null;
            $scope.$watch('searchTerm', function(newVal, oldVal) {
                if (newVal == oldVal) {
                    return;
                }

                window.localStorage.setItem('campaignSearchTerm', $scope.searchTerm);

                if (filterTimeout) {
                    $timeout.cancel(filterTimeout);
                }

                filterTimeout = $timeout(function() {
                    $scope.filter();
                }, 700);
            });

            $scope.$watch('ioFilter', function(newVal, oldVal) {
                if (newVal && oldVal && newVal !== oldVal) {
                    window.localStorage.setItem('ioFilter', $scope.ioFilter);
                    $scope.filter();
                }
            });

            $scope.$watch('advertisersFilter', function(newVal, oldVal) {
                if (newVal && oldVal && newVal !== oldVal) {
                    window.localStorage.setItem('advertisersFilter', JSON.stringify($scope.advertisersFilter));
                    $scope.filter();
                }
            }, true);
            $scope.$watch('agenciesFilter', function(newVal, oldVal) {
                if (newVal && oldVal && newVal !== oldVal) {
                    window.localStorage.setItem('agenciesFilter', JSON.stringify($scope.agenciesFilter));
                    $scope.filter();
                }
            }, true);

            $scope.$watch('usersFilter', function(newVal, oldVal) {
                if (newVal && oldVal && newVal !== oldVal) {
                    window.localStorage.setItem('usersFilter', JSON.stringify($scope.usersFilter));
                    $scope.filter();
                }
            }, true);


            $scope.filter = function() {
                $scope.page.number = 0;
                $scope.fetch();
            };

            $scope.getAdvertisersFilter = function() {
              if ($scope.advertisersFilter.length === window.advertisers.length) {
                  return [];
              }
              return $scope.advertisersFilter;
            };
            $scope.getAgenciesFilter = function() {
                if ($scope.agenciesFilter.length === window.agencies.length) {
                    return [];
                }
                return $scope.agenciesFilter;
            };
            $scope.getUsersFilter = function() {
                if ($scope.usersFilter.length === window.users.length) {
                    return [];
                }
                return $scope.usersFilter;
            };

            /**
             * Fetch list data from server
             */
            $scope.fetch = function() {
                $scope.loading = true;

                campaignApi
                    .getList($scope.sort, $scope.searchTerm, $scope.page, $scope.ioFilter, $scope.campaignTypeFilter, $scope.statusFilter, $scope.exHdlFilter, $scope.getAdvertisersFilter(), $scope.getAgenciesFilter(), $scope.getUsersFilter())
                    .then(
                        function(data) {
                            $scope.list = {
                                count: data.count,
                                data: data.data,
                                maxPage: Math.floor(data.count / $scope.page.size),
                            };
                            if (data.data.length > 0) {
                                var cids = [];
                                for (var i = 0; i < data.data.length; i++) {
                                    cids.push(data.data[i]['_id']);
                                }

                                if (optionsApi.isUseCdp()) {
                                    campaignApi.getCampaignStatCDP(cids).then(function (stat) {
                                        for (i = 0; i < $scope.list.data.length; i++) {
                                            var cid = $scope.list.data[i]['_id'];
                                            $scope.list.data[i].budget_spent = stat[cid] ? stat[cid].sum_cost / 1000000 : 0;
                                            $scope.list.data[i].ctr_stat = stat[cid] && stat[cid].impressionsTotal
                                                ? ((stat[cid].clicksTotal / stat[cid].impressionsTotal) * 100).toString()
                                                : '0';
                                            $scope.list.data[i].imps_stat = stat[cid] && stat[cid].impressionsStr ? stat[cid].impressionsStr : 'N/A';
                                            $scope.list.data[i].clicks_stat = stat[cid] && stat[cid].clicksStr ? stat[cid].clicksStr : 'N/A';
                                            $scope.list.data[i].stat =  stat[cid].stat;
                                            $scope.list.data[i].delivery_log =  stat[cid].log;

                                        }
                                    });
                                } else {
                                    campaignApi.getCampaignStat(cids).then(function(stat) {
                                        var stat_hash = {};
                                        for (var i = 0; i < stat.length; i++) {
                                            stat_hash[stat[i]['cid']] = stat[i];
                                        }
                                        for (i = 0; i < $scope.list.data.length; i++) {
                                            $scope.list.data[i].imps_actual = stat_hash[$scope.list.data[i]['_id']]
                                                ? stat_hash[$scope.list.data[i]['_id']].n_impression
                                                : 0;
                                            $scope.list.data[i].budget_spent = stat_hash[$scope.list.data[i]['_id']]
                                                ? stat_hash[$scope.list.data[i]['_id']].sum_cost / 1000000
                                                : 0;

                                            $scope.list.data[i].ctr_stat = stat_hash[$scope.list.data[i]['_id']]  && stat_hash[$scope.list.data[i]['_id']].n_impression
                                                ? ((stat_hash[$scope.list.data[i]['_id']].n_click / stat_hash[$scope.list.data[i]['_id']].n_impression)*100).toString()
                                                : '0';



                                            var impressions = 0;
                                            if (stat_hash[$scope.list.data[i]['_id']] && stat_hash[$scope.list.data[i]['_id']].n_impression) {
                                                impressions = stat_hash[$scope.list.data[i]['_id']].n_impression;
                                            }
                                            var clicks = 0;
                                            if (stat_hash[$scope.list.data[i]['_id']] && stat_hash[$scope.list.data[i]['_id']].n_click) {
                                                clicks = stat_hash[$scope.list.data[i]['_id']].n_click;
                                            }
                                            var imps_value_str = ' - ';
                                            var clicks_value_str = ' - ';
                                            var active_days = 0;
                                            var total_goal = 0;

                                            switch ($scope.list.data[i]['goal_type']){
                                                case 1:  // per day imps
                                                    active_days = Math.floor(($scope.list.data[i]['end'] - $scope.list.data[i]['start'])/(1000 * 60 * 60 * 24)).toFixed();
                                                    total_goal = $scope.list.data[i]['goal_value'] * active_days;
                                                    imps_value_str = impressions.toString() + ' / ' + total_goal + '; ';
                                                    clicks_value_str = clicks.toString() + '; ';
                                                    break;
                                                case 2: // total imps
                                                    imps_value_str =  impressions.toString() + ' / ' + $scope.list.data[i]['goal_value'] + '; ';
                                                    clicks_value_str = clicks.toString() + '; ';
                                                    break;
                                                case 3:  // per day clicks
                                                    active_days = Math.floor(($scope.list.data[i]['end'] - $scope.list.data[i]['start'])/(1000 * 60 * 60 * 24)).toFixed();
                                                    total_goal = $scope.list.data[i]['goal_value'] * active_days;
                                                    imps_value_str = impressions.toString()  + '; ';
                                                    clicks_value_str = clicks.toString() + ' / ' + total_goal + '; ';
                                                    break;
                                                case 4: // total clicks
                                                    imps_value_str =  impressions.toString() + '; ';
                                                    clicks_value_str = clicks.toString() + ' / ' + $scope.list.data[i]['goal_value'] +  '; ';
                                                    break;
                                                default:
                                                    imps_value_str = '- / -; '
                                            }

                                            $scope.list.data[i].imps_stat = imps_value_str;
                                            $scope.list.data[i].clicks_stat = clicks_value_str;
                                        }

                                        // today stats
                                        campaignApi.getCampaignStatToday(cids).then(function(stat) {
                                            var stat_hash = {};
                                            for (var i = 0; i < stat.length; i++) {
                                                stat_hash[stat[i]['cid']] = stat[i];
                                            }
                                            for (i = 0; i < $scope.list.data.length; i++) {
                                                var impressions = 0;
                                                if (stat_hash[$scope.list.data[i]['_id']] && stat_hash[$scope.list.data[i]['_id']].n_impression) {
                                                    impressions = stat_hash[$scope.list.data[i]['_id']].n_impression;
                                                }
                                                var clicks = 0;
                                                if (stat_hash[$scope.list.data[i]['_id']] && stat_hash[$scope.list.data[i]['_id']].n_click) {
                                                    clicks = stat_hash[$scope.list.data[i]['_id']].n_click;
                                                }
                                                var imps_value_str = ' - ';
                                                var clicks_value_str = ' - ';
                                                var today_goal = '0'
                                                switch ($scope.list.data[i]['goal_type']){
                                                    case 1:  // per day imps
                                                        today_goal = $scope.list.data[i]['goal_value'] + '';
                                                        imps_value_str = impressions.toString() + ' / ' + today_goal;
                                                        clicks_value_str = clicks.toString() + '';
                                                        break;
                                                    case 2: // total imps
                                                        today_goal = ($scope.list.data[i]['goal_value'] / Math.floor(($scope.list.data[i]['end'] - $scope.list.data[i]['start'])/(1000 * 60 * 60 * 24))).toFixed();
                                                        imps_value_str = impressions.toString() + ' / ' + today_goal;
                                                        clicks_value_str = clicks.toString() + '';
                                                        break;
                                                    case 3:  // per day clicks
                                                        imps_value_str = impressions + '';
                                                        clicks_value_str = clicks.toString() + ' / ' + $scope.list.data[i]['goal_value'];
                                                        break;
                                                    case 4: // total clicks
                                                        imps_value_str = impressions + '';
                                                        today_goal = ($scope.list.data[i]['goal_value'] / Math.floor(($scope.list.data[i]['end'] - $scope.list.data[i]['start'])/(1000 * 60 * 60 * 24))).toFixed();
                                                        clicks_value_str = clicks.toString() + ' / ' + today_goal;
                                                        break;

                                                    default:
                                                        today_goal = '-';
                                                        imps_value_str = impressions.toString() + ' / ' + today_goal;
                                                        clicks_value_str = clicks.toString();
                                                }

                                                $scope.list.data[i].imps_stat += imps_value_str;
                                                $scope.list.data[i].clicks_stat += clicks_value_str;
                                            }
                                        });

                                    });

                                }

                            }
                            $scope.loading = false;
                        },
                        function() {
                            $scope.list = {
                                count: 0,
                                data: [],
                                maxPage: null,
                            };
                            $scope.loading = false;
                        }
                    );
            };

            /**
             * set page to new value and load data
             * @param page
             */
            $scope.setPage = function(page) {
                $scope.page.number = page;

                $scope.fetch();
            };

            /**
             * get the sort css for a given column
             * @param field
             * @returns {*}
             */
            $scope.getSortCssClass = function(field) {
                if ($scope.sort.field === field) {
                    return 'fa-sort-' + $scope.sort.order;
                } else {
                    return 'fa-sort';
                }
            };

            /**
             * update sorting and fetch data
             * @param field
             */
            $scope.setSort = function(field) {
                $scope.page.number = 0;

                if ($scope.sort.field === field) {
                    $scope.sort.order = $scope.sort.order === 'desc' ? 'asc' : 'desc';
                } else {
                    $scope.sort.field = field;
                    $scope.sort.order = 'desc';
                }

                $scope.fetch();
            };

            /**
             * toggle active/inactive
             * @param campaign
             */
            $scope.toggleActive = function(campaign) {
                campaignApi.toggleActive(campaign._id).then(function() {
                    campaign.active = !campaign.active;
                });
            };

            /**
             * show the delete confirmation dialog
             * @param campaign
             */
            $scope.promptDelete = function(campaign) {
                $scope.campaignToDetele = campaign;
                $('#delete-modal').modal('show');
            };

            /**
             * show the delete confirmation dialog
             * @param campaign
             */
            $scope.promptToggle = function(campaign) {
                $scope.campaignToToggle = campaign;
                $('#toggle-modal').modal('show');
            };


            /**
             * delete a Campaign
             * @param campaign
             */
            $scope.delete = function(campaign) {
                campaignApi.delete(campaign._id).then(function() {
                    $scope.fetch();
                });
            };

            /**
             * show the duplicate confirmation dialog
             * @param campaign
             */
            $scope.promptDuplicateCamp = function(campaign) {
                campaignApi.duplicateCheck(campaign._id).then(function(data) {
                    if (data.data.status == 'success') {
                        $scope.campaignToDuplicate = campaign;
                        $('#duplicate-modal').modal('show');
                    } else {
                        $scope.errorModalTitle = "Error";
                        $scope.errorModalText = data.data.message;
                        $('#error-modal').modal('show');
                    }

                });
            };

            /**
             * duplicate an campaign
             * @param campaign
             */
            $scope.duplicate = function(campaign) {
                campaignApi.duplicate(campaign._id).then(function() {
                    $scope.fetch();
                });
            };

            /**
             * export list to csv
             */
            $scope.exportAll = function() {
                var url = '/demandmgr/campaign/exportAll';

                url = url + '?sortField=' + $scope.sort.field;
                url = url + '&sortOrder=' + $scope.sort.order;
                url = url + '&search=' + $scope.searchTerm;

                window.location.href = url;
            };

            /**
             * open a Campaign creating/editing form
             * @param campaignId
             */
            $scope.openCampaignForm = function(campaignId) {
                window.location.href = '/#!/demandmgr/campaign/edit?id=' + campaignId;
            };

            $scope.fetch();
        },
    ]);
})(window.angular);
